var Confs = Class.extend({
    langs : ['it'],
    current_lang : 'it',
    /**
     * ritorna una istanza della classe definita come configurazione per il modello passato
     * se esiste una classi di configurazione per ruolo vince quella per ruolo
     * @param model : nome modello
     * @param action : tipo di configurazione in edit,list,insert ecc
     * @param role : ruolo dell'utente.
     */
    getConf : function (model,action,role) {
        var className = "Model_"+Utility.pascalCase(model);
        var classNameRole = className + (role?Utility.pascalCase(role):"");
        var defaultClass = Utility.pascalCase(action)+"Confs";

        //log.debug('checking ' + className + " or " + classNameRole);

        //log.debug('checking configuration action ' + action +  ' for  ' + model + " className " + className);
        if (window[classNameRole] && window[classNameRole][action]) {
            log.debug('loaded Conf ' + classNameRole + "." + action);
            return new window[classNameRole][action];
        }

        //log.debug('checking configuration action ' + action +  ' for  ' + model + " className " + className);
        if (window[className] && window[className][action]) {
            log.debug('loaded Conf ' + className + "." + action);
            return new window[className][action];
        }

        // il caso speciale action insert se non c'e' e' uguale all'edit
        if (action == 'insert') {
            if (window[className] && window[className]['edit']) {
                log.debug('loaded Conf ' + className + ".insert" );
                return new window[className]['edit'];
            }
        }
        log.debug('not found loading default className ' + defaultClass);
        return new window[defaultClass];



        // var className = "Model_"+Utility.pascalCase(model);
        // className += role?Utility.pascalCase(role):"";
        //
        // var defaultClass = Utility.pascalCase(action)+"Confs";
        // log.debug('checking configuration action ' + action +  ' for  ' + model + " className " + className);
        // if (window[className] && window[className][action]) {
        //     return new window[className][action];
        // }
        // // il caso speciale action insert se non c'e' e' uguale all'edit
        // if (action == 'insert') {
        //     if (window[className] && window[className]['edit']) {
        //         return new window[className]['edit'];
        //     }
        // }
        // log.debug('not found loading default className ' + defaultClass);
        // return new window[defaultClass];
    },
    getLangs : function () {
        return this.langs;
    }
});